<template>
  <div class="model_container">
    <div v-if="!articleDetailDialogVisible">
      <el-form :model="searchForm" label-position="top" action="javascript:void(0)">
        <el-form-item label="搜索">
          <el-input v-model="searchForm.searchKeyword" placeholder="请输入关键词" @clear="searchArticle" clearable></el-input>
        </el-form-item>
        <el-form-item label="文章来源">
          <el-radio-group v-model="searchForm.source" size="small">
            <el-radio-button label="1">参考文章</el-radio-button>
            <el-radio-button label="2">我的文章库</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" native-type="submit" @click="searchArticle" style="display: none;">查询</el-button>
        </el-form-item>
      </el-form>
      <div class="cardContainer ">
        <template v-if="searchForm.source === '1'">
          <div style="
font-size: 13.48px;
font-weight: 700;
line-height: 16.32px;
color: rgba(60, 66, 88, 1);
text-align: left;
vertical-align: top;">参考文章</div>
          <div class="scrollContainer" style="overflow-y: scroll;height: calc(100vh - 345px); margin-top: 15px;">
            <div v-for="(item) in articleRelateList" :key="item.id">
              <articleExtendCard @openDetail='openNewDetail(item.id, "relation")'
                @insertToArticle="insertDescToArticle(item.summary)" :showDesc=true :article='item' />
            </div>
            <div v-for="(item) in articleExtendList" :key="item.id" class="scrollContainer">
              <articleExtendCard @openDetail='openNewDetail(item.id, "extend")'
                @insertToArticle="insertDescToArticle(item.summary)" :article='item' :showDesc=true :key="item.id" />
            </div>
            <div v-if="articleSearchList && articleSearchList.length > 0" class="scrollContainer"
              style="height: calc(100vh - 370px); margin-top: 15px;overflow-y:auto"
              v-infinite-scroll="loadMoreSearchArticles" :infinite-scroll-immediate=true :infinite-scroll-delay=500
              :infinite-scroll-disabled='searchArticleLoadingFinish'>
              <div v-for="(item) in articleSearchList" :key="item.id" class="scrollContainer">
                <articleExtendCard @openDetail='openNewDetail(item.id, "search")'
                  @insertToArticle="insertDescToArticle(item.summary)" :article='item' :showDesc=true :key="item.id" />
              </div>
            </div>
          </div>
        </template>
        <template v-if="searchForm.source === '2'">
          <div
            style="font-size: 13.48px;font-weight: 700;line-height: 16.32px;color: rgba(60, 66, 88, 1);text-align: left;vertical-align: top;">
            我的文章库</div>
          <div>
            <div class="scrollContainer" style="height: calc(100vh - 345px); margin-top: 15px;overflow-y:auto"
              v-infinite-scroll="searchArticlesByPage" :infinite-scroll-immediate=true :infinite-scroll-delay=500
              :infinite-scroll-disabled='articleLoadingFinish'>
              <ul style="width:100%;margin: 0;padding: 0;">
                <li v-for="item in myArticles" :key="item.id" class="infinite-list-item">
                  <articleExtendCard @openDetail='openNewDetail(item.id, "my")' :article='item' articleType='my'
                    :showDesc=true :key="item.id" />
                </li>
                <template v-if="articleLoadingFinish">
                  <div class="noData">
                    <i class="iconfont">&#xe629;</i>
                    数据加载完毕!
                  </div>
                </template>
                <template v-else>
                  <div class="noData">
                    <span class="icon_run">
                      <i class="iconfont">&#xe67b;</i>
                    </span>数据加载中...
                  </div>
                </template>
              </ul>
            </div>
          </div>
        </template>
      </div>
    </div>
    <!--延伸文章 等详情Dialog--->
    <div class="newsDetailDialogContainer" v-if="articleDetailDialogVisible">
      <el-row>
        <el-form :model="searchForm" label-position="top">
          <el-col :span="12">
            <el-form-item label="参考文章">
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <div style="clear: both;height: 9px;"></div>
            <el-link :underline="false" class="f_r" @click="articleDetailDialogVisible = false"><i
                class="iconfont">&#xe69f;</i>&nbsp;</el-link>
          </el-col>
        </el-form>

        <el-col :span="24">
          <el-row class="sourceNewsTitle">
            <div class="title">
              <el-link :underline="false" target="_blank" :href='curNews.url'> {{ curNews.title }}</el-link>
            </div>
            &nbsp;
            <div class="report">
              <el-link :underline="false" @click="toReport">
                <i class="iconfont_yx" style="color: #f39e1eed;">&#xe675;</i>
              </el-link>
            </div>
            <br> <br>
          </el-row>
          <el-row class="newsSourceInfo">
            <el-form label-position="top">
              <el-form-item label="句子类型">
                <el-radio-group size="small" v-model="sourceArticleTab">
                  <el-radio-button label="原文素材"></el-radio-button>
                  <el-radio-button
                    v-if="curSentenceTypes.sentenceTypeTime && curSentenceTypes.sentenceTypeTime.length != 0"
                    label="事件发展"></el-radio-button>
                  <el-radio-button
                    v-if="curSentenceTypes.sentenceTypeView && curSentenceTypes.sentenceTypeView.length != 0"
                    label="人物观点"></el-radio-button>
                  <el-radio-button
                    v-if="curSentenceTypes.sentenceTypeMajor && curSentenceTypes.sentenceTypeMajor.length != 0"
                    label="文章强调"></el-radio-button>
                </el-radio-group>
              </el-form-item>
            </el-form>
          </el-row>
          <el-row>
            <div class="scrollContainer" style="overflow-y: scroll;height: calc(100vh - 345px); margin-top: 15px;">
              <div v-if="sourceArticleTab === '原文素材'">
                <div v-for="(item, index) in curNews.sentenceList" :key="index" class="item_left">
                  <div class="sentenceContent" v-html="item"></div>
                  <div class="t_r">
                    <el-link :underline="false" @click="insertDescToArticle(item)">
                      <div class="insertBtn"></div>
                    </el-link>
                  </div>
                </div>
              </div>
              <div v-if="sourceArticleTab === '事件发展'">
                <div v-for="(item, index) in curSentenceTypes.sentenceTypeTime" :key="index" class="item_left">
                  <div class="sentenceContent" v-html="item"></div>
                  <div class="t_r">
                    <el-link :underline="false" @click="insertDescToArticle(item)">
                      <div class="insertBtn"></div>
                    </el-link>
                  </div>
                </div>
              </div>
              <div v-if="sourceArticleTab === '人物观点'">
                <div v-for="(item, index) in curSentenceTypes.sentenceTypeView" :key="index" class="item_left">
                  <div class="sentenceContent" v-html="item"></div>
                  <div class="t_r">
                    <el-link :underline="false" @click="insertDescToArticle(item)">
                      <div class="insertBtn"></div>
                    </el-link>
                  </div>
                </div>
              </div>
              <div v-if="sourceArticleTab === '文章强调'">
                <div v-for="(item, index) in curSentenceTypes.sentenceTypeMajor" :key="index" class="item_left">
                  <div class="sentenceContent" v-html="item"></div>
                  <div class="t_r">
                    <el-link :underline="false" @click="insertDescToArticle(item)">
                      <div class="insertBtn"></div>
                    </el-link>
                  </div>
                </div>
              </div>
            </div>

          </el-row>
        </el-col>

      </el-row>
    </div>
  </div>
</template>
<script>
import draggable from 'vuedraggable'
import articleExtendCard from '../article_extend_card.vue'
import * as appJs from '../../assets/js/app'
export default {
  props: ['articleId', 'articleInfo', 'articleExtendTag', 'searchKey'],
  components: {
    articleExtendCard,
    draggable
  },
  name: 'myArticle',
  data: function () {
    return {

      articlePageNo: 0,
      articleLoadingFinish: false,
      myArticles: [],
      searchArticlePage: 1,
      searchArticleLoadingFinish: false,
      searchArticleLoading: false,

      searchForm: {
        searchKeyword: '',
        source: '1'
      },
      curNews: {},

      curSentenceTypes: {}, // 当前新闻的扩展

      sourceArticleTab: '原文素材',
      historyArray: [],
      curDialogType: '',

      articleDetailDialogVisible: false,
      articleContentArray: [],
      appendContent: '',
      articleExtendList: [], // 延伸文章
      articleExtendCandition: [], // 延伸文章

      articleRelateList: [], // 相关文章
      articleRelateCandition: [],

      articleSearchList: [], // 搜索文章
      extendArticleTimes: 0,
      relateLoding: true,
      relateEmpty: false,
      extendLoading: true,
      tempHistoryLock: true,
      extendEmpty: false,
      lastArticleId: -1

    }
  },
  metaInfo () {
    return {
      title: '弈写AI辅助写作'
    }
  },
  methods: {
    removeItemFromArticle (index) {
      this.articleContentArray.splice(index, 1)
    },
    // p 标签内的编辑
    handleEditSection (index, html) {
      this.articleContentArray[index] = html
    },
    handBlueSection (index, html) {
      this.updateArticleContent()
    },
    toReport () {
      this.$emit('toReport', null, this.tempCurNewsId, this.curNews.title)
    },
    insertDescToArticle (val) {
      this.$emit('insert', val)
    },
    appndContentToArray () {
      this.articleContentArray.push(this.appendContent)
      this.updateArticleContent()
    },
    updateArticleContent () {
      let temp = ''
      this.articleContentArray.forEach(a => {
        temp = temp + '<p>' + a + '</a>'
      })
      this.$emit('modifyArticleContent', temp)
      this.$forceUpdate()
    },

    // 打开文章详情
    openNewDetail (newsId, type) {
      appJs.isVip().then(() => {
        // debugger
        this.tempCurNewsId = newsId
        this.curDialogType = type

        this.sourceArticleTab = '原文素材'
        let _this = this
        _this.curSentenceTypes = ''
        _this.curNews = {}

        this.articleDetailDialogVisible = true
        this.curSentenceTypes = {}
        if (type === 'my') {
          this.axios.get('/webApi/v3/article/hisArticleDetail?articleId=' + newsId).then((response) => {
            _this.curNews = response.data
            _this.curNews.sentenceList = response.data.contentArray
            _this.curSentenceTypes = response.data.sentenceTypes
          })
          return
        }

        this.axios.post('/webApi/v3/assist/news-detail', { 'newsId': newsId }).then((response) => {
          _this.curSentenceTypes = response.data.sentenceTypes
          _this.curNews = response.data.newsObj
        })
      })
    },
    searchArticle () {
      console.log('搜索文章')
      if (this.searchForm.source === '1') {
        this.articleSearchList = []
        this.articleRelateList = []
        this.articleExtendList = []
        if (this.searchForm.searchKeyword) {
          this.searchArticlePage = 1;
          this.loadMoreSearchArticles()
        } else {
          this.articleRelateList = this.articleRelateCandition
          this.articleExtendList = this.articleExtendCandition
        }
      }
      if (this.searchForm.source === '2') {
        this.searchMyArticle()
      }
    },
    loadMoreSearchArticles () {
      if (this.searchArticleLoading) {
        return
      }
      this.searchArticleLoading = true
      let _this = this
      this.axios.get(`/webApi/v3/assist/search-cn-news?sortType=sortScore&searchWords=${_this.searchForm.searchKeyword}&page=${_this.searchArticlePage}`).then((response) => {
        _this.articleSearchList = _this.articleSearchList.concat(response.data.rows)
        _this.searchArticleLoading = false
        if (response.data.total <= _this.searchArticlePage * 20) {
          _this.searchArticleLoadingFinish = true
        } else {
          _this.searchArticlePage++
          if (!_this.searchArticleLoadingFinish && _this.articleSearchList.length < 10) {
            _this.loadMoreSearchArticles()
          }
        }
      })
    },
    searchArticlesByPage () {
      this.articlePageNo = this.articlePageNo + 1
      this.searchArticles()
    },
    searchMyArticle () {
      this.articlePageNo = 1
      this.myArticles = []
      this.articleLoadingFinish = false
      this.searchArticles()
    },
    // 搜索文章
    async searchArticles () {
      let _this = this
      if (!this.articleLoadingFinish) {
        await this.axios.get(`/webApi/v3/article/myListData?keyword=${_this.searchForm.searchKeyword}&articleId=${this.lastArticleId}&fileType=NEWS`).then((response) => {
          if (response && response.data && response.data.length > 0) {
            response.data.forEach(n => {
              if (n.keywords) {
                n.keywords = n.keywords.split(',', 3).toString()
              }

              if (_this.articleId && _this.articleId !== n.id) {
                _this.myArticles.push(n)
              }
              _this.lastArticleId = response.data.slice(-1)[0].id
            })
          } else {
            _this.articleLoadingFinish = true
          }
        })
      }
    },
    // 延伸文章
    getExtentdArticles () {
      let _this = this
      this.axios.post('/webApi/v3/article/detail-extend', { 'articleId': _this.articleId, '$noLoading': true }).then((response) => {
        if (response.data.extendNewsList) {
          _this.articleExtendCandition = response.data.extendNewsList
          _this.articleExtendList = _this.articleExtendCandition
          if (response.data.extendNewsList !== 0) {
            _this.extendLoading = false
            _this.extendEmpty = false
            return
          }
        }
        setTimeout(function () {
          _this.extendArticleTimes++
          if (_this.extendArticleTimes < 30) {
            _this.getExtentdArticles()
          } else {
            _this.extendLoading = false
            _this.extendEmpty = true
          }
        }, 2000)
      })
    },

    // 相关文章
    getRelateArticles () {
      let _this = this
      console.log('获取相关文章' + _this.articleId)
      this.axios.post('/webApi/v3/article/detail-relate', { 'articleId': _this.articleId }).then((response) => {
        _this.articleRelateCandition = response.data.sourceNewsList
        _this.articleRelateList = _this.articleRelateCandition
        _this.relateLoding = false
      })
    }

  },

  computed: {

  },
  watch: {
    childArticleExtendTag: function (v) {
      let _this = this
      switch (v) {
        case 'extends':
          if (_this.articleExtendList.length === 0) {
            this.getExtentdArticles()
          }

          break
        case 'my':
          if (_this.myArticles.length === 0) {
            this.searchMyArticle()
          }
          break
      }
    },

    articleExtendTag: function () {
      if (this.articleExtendTag) {
        this.childArticleExtendTag = this.articleExtendTag
      }
    },
    searchKey: function () {
      if (this.searchKey) {
        this.searchForm.searchKeyword = this.searchKey
        this.searchArticle()
      }
    }
  },
  mounted () {
    let _this = this
    appJs.isVip().then(() => {
      _this.getExtentdArticles()
      _this.searchMyArticle()
    })
    console.log(this.articleId)
    if (this.articleId) {
      this.getRelateArticles()
    }
  }
}

</script>
<style lang="less">
.articleTab {
  .cardContainer {
    height: calc(100vh - 300px);
    overflow-y: auto;
  }

  .loading {
    background-image: url("../../assets/imgs/loading.png");
    width: 150px;
    height: 150px;
    background-size: contain;
    margin: auto;
    margin-top: 50px;
  }

  .loading::after {
    content: "加载中...";
    color: #989FB0;
    position: relative;
    top: 100%;
  }

  .empty {
    background-image: url("../../assets/imgs/empty.png");
    width: 150px;
    height: 150px;
    background-size: contain;
    margin: auto;
    margin-top: 50px;

  }

  .empty::after {
    content: "无数据...";
    color: #989FB0;
    position: relative;
    top: 100%;
  }

}

.newsDetailDialogContainer {
  position: absolute;
  background-color: white;
  width: 100%;
  min-height: 100%;
  top: 0px;
  text-align: left;
  border-radius: 10px;
  padding: 10px;
  box-sizing: border-box;

  .sourceNewsTitle {
    font-size: 16px;
    display: flex;
  }

}
</style>



// WEBPACK FOOTER //
// src/components/article/articleTab.vue